import { Box, Button, Chip, Stack, Tooltip } from '@mui/material';
import { EnableInventoryLookup, formatStateFilterLabel } from 'common/utils';
import { compact, isEmpty, values } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { filterBulkLabelHistory } from 'store/thunks/workQueueThunks';
import FacilityFilterStatusChip from './FacilityFilterStatusChip';

const BulkLabelPrintHistoryFilterStatusBar = () => {
  const dispatch = useDispatch();
  const filter = useSelector(({ workQueue }) => workQueue.bulkLabels?.bulkLabelHistory?.filter);

  const removeFilter = (filterName) => () =>
    dispatch(filterBulkLabelHistory({ filter: { ...filter, [filterName]: undefined } }));

  const removeAllFilter = () => dispatch(filterBulkLabelHistory({ filter: {} }));

  return (
    <Stack direction='row' spacing={1}>
      <FacilityFilterStatusChip
        removeFilter={removeFilter}
        selectedFacilities={filter?.fulfillingPharmacyIds || []}
      />

      {filter?.pomUserName && (
        <Chip
          label={`User Name = ${filter.pomUserName}`}
          variant='contained'
          onDelete={removeFilter('pomUserName')}
        />
      )}

      {EnableInventoryLookup && !isEmpty(filter?.ndcs) && (
        <Chip
          label={
            <Tooltip title={filter.ndcs.join(', ')}>
              <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {formatStateFilterLabel(filter.ndcs, 'NDC')}
              </Box>
            </Tooltip>
          }
          variant='contained'
          onDelete={removeFilter('ndcs')}
        />
      )}

      {filter?.createdBetween && (
        <Chip
          label={
            !filter.createdBetween?.toDate ||
            filter.createdBetween.toDate === filter.createdBetween.fromDate
              ? `Created On = ${filter.createdBetween.fromDate}`
              : `Created Between = ${filter.createdBetween.fromDate} - ${filter.createdBetween.toDate}`
          }
          variant='contained'
          onDelete={removeFilter('createdBetween')}
        />
      )}

      {!isEmpty(compact(values(filter))) && <Button onClick={removeAllFilter}>Remove All</Button>}
    </Stack>
  );
};

export default BulkLabelPrintHistoryFilterStatusBar;
